module.exports = __webpack_public_path__ + "img/VOLG.02a38a27.png";